import { render } from "./FacePhraseForIndexPage.vue?vue&type=template&id=e1245572&scoped=true"
import script from "./FacePhraseForIndexPage.vue?vue&type=script&lang=js"
export * from "./FacePhraseForIndexPage.vue?vue&type=script&lang=js"

import "./FacePhraseForIndexPage.vue?vue&type=style&index=0&id=e1245572&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1245572"

export default script